import React, { useEffect, useState } from "react";
import { Form, Skeleton, message, Row, Col } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans, InputDate, SelectWithSearch, SelectResourceList } from "@comps/components"
import { makeRequest, makeRequestStateless, getErrorProps } from "@utils/helpers";
import { createDataReq, getEmployeeRelatedDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { getEmploymentsDataReq } from "@mods/common/requests";
import { createSelectList } from '@comps/commonFunctions';
import { makeFieldLabel } from "@utils/fieldTooltips";
import { transferTooltips } from "../../../common/transferTooltips";

const langKey = Const["companyPromotions"].lngKey

const fieldLabel = makeFieldLabel(transferTooltips.promotion, { namespace: "promotion", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createPromotionRequest";
const CreateSubordinatePromotionRequest = (props) => {

  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saveLoader, setSaveLoader] = useState(false);
  const [errors, setErrors] = useState([]);
  const [designations, setDesignations] = useState([]);
  const [jobtitles, setJobtitles] = useState([]);
  const [grades, setGrades] = useState([]);
  const [emoloyeeInfo, setEmoloyeeInfo] = useState({});

  const [form] = Form.useForm()
  useEffect(() => {
    getEmployments()
    setData()
    // eslint-disable-next-line
  }, []);

  const setData = () => {
    setGrades(createSelectList(props.allData.grades))
    setDesignations(createSelectList(props.allData.designations))
    setJobtitles(createSelectList(props.allData.job_titles))
  }
  const getEmployments = () => {
    const payload = { filters: null }
    makeRequestStateless(getEmploymentsDataReq, payload, onGetEmployments, false)
  }
  const onGetEmployments = (response) => {
    setLoading(false)
  }

  const onChangeEmployments = (id) => {
    const payload = {
      employment_id: id
    }
    makeRequest(setLoader, getEmployeeRelatedDataReq, payload, onGetEmployeeData, onGetEmployeeDataError);
  }
  const onGetEmployeeData = (response) => {
    setEmoloyeeInfo(response)
    form.setFieldsValue(
      {
        grade_id: response.grade_id,
        designation_id: response.designation_id,
        job_title_id: response.job_title_id,
        prev_salary: response.salary
      }
    )
  }
  const onGetEmployeeDataError = (response) => {

  }
  const onSubmit = (data) => {
    let gradeObj = {}
    props.allData.grades.forEach(grade => {
      if (grade.id === data.grade_id) {
        gradeObj = grade;
      }
    })
    const payload = {
      'file_attachment': 'undefined',
      'promotion': {
        "behalf_employment_id": props.authUser.employment_id, "is_on_behalf": true, "employment_id": data.employment_id, "grade_id": data.grade_id, "grade_level_id": null, "job_title_id": data.job_title_id, "designation_id": data.designation_id, "prev_salary": data.prev_salary, "is_hourly": emoloyeeInfo.is_hourly, "joining_date": emoloyeeInfo.joining_date,
        "salary_benefits": emoloyeeInfo.salary ? emoloyeeInfo.salary_benefits : [],
        "date": data.date.format('YYYY-MM-DD'),
        "grade":
          gradeObj,
        "is_demotion": data.is_demotion, "salary": data.salary, "description": data.description,
        "benefit_ids": []
      }
    }
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
    setSaveLoader(true)
  }

  const onSuccess = (data, res) => {

    setSaveLoader(false)
    message.success("Saved successfully");
    props.onCompleted(data.promotions.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {

    setSaveLoader(false)
    message.error(res.response.data.message);
  }
  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------
  const footer = [
    <SaveButton loading={ saveLoader } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];
  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------
  return (
    <ModalComponent top={ 20 } width={ 680 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Skeleton loading={ loading }>
        <Form { ...formLayout } form={ form } name={ formName } onFinish={ onSubmit }>
          <Row gutter={ 30 }>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="employment_id" rules={ rules.employment_id } label={ fieldLabel("employment_id", trans(`${langKey}.employment_id`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectResourceList type='employment'
                  onChange={ onChangeEmployments }
                />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="is_demotion" rules={ rules.is_demotion } label={ fieldLabel("is_demotion", trans(`${langKey}.is_demotion`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['name']) } size="small"
              >
                <SelectWithSearch
                  options={ [
                    {
                      label: 'Promotion',
                      value: false
                    },
                    {
                      label: 'Demotion',
                      value: true
                    },
                  ] }
                  placeholder={ trans(`${langKey}.is_demotion`) }

                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="grade_id" rules={ rules.grade_id } label={ fieldLabel("grade_id", trans(`${langKey}.grade_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.grade_id`) }

                  options={ grades }
                />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="designation_id" rules={ rules.designation_id } label={ fieldLabel("designation_id", trans(`${langKey}.designation_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.designation_id`) }
                  options={ designations }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="job_title_id" rules={ rules.job_title_id } label={ fieldLabel("job_title_id", trans(`${langKey}.job_title_id`)) }
                className="da-mb-16"
                size="small"
              >
                <SelectWithSearch
                  placeholder={ trans(`${langKey}.job_title_id`) }
                  options={ jobtitles }
                />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="prev_salary" rules={ rules.prev_salary } label={ fieldLabel("prev_salary", trans(`${langKey}.prev_salary`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['prev_salary']) } size="small"
              >
                <InputText type="number" onWheel={(e) => e.target.blur()} placeholder="prev_salary" disabled={ true } />
              </Form.Item>
            </Col>
            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="salary" rules={ rules.salary } label={ fieldLabel("salary", trans(`${langKey}.salary`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['salary']) } size="small"
              >
                <InputText type="number" onWheel={(e) => e.target.blur()} placeholder={ trans(`${langKey}.salary`) } />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="date" rules={ rules.date } label={ fieldLabel("date", trans(`${langKey}.date`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['date']) } size="small"
              >
                <InputDate />
              </Form.Item>
            </Col>

            <Col lg={ 12 } sm={ 24 } xs={ 24 }>
              <Form.Item name="description" rules={ rules.description } label={ fieldLabel("description", trans(`${langKey}.description`)) }
                className="da-mb-16"
                { ...getErrorProps(errors['description']) } size="small"
              >
                <InputTextArea placeholder={ trans(`${langKey}.description`) } />
              </Form.Item>
            </Col>
          </Row>

        </Form>
      </Skeleton>
    </ModalComponent>
  )
}

export default CreateSubordinatePromotionRequest

const rules = {
  date: [
    { required: true, message: trans(`${langKey}.date.req`) },
  ],
  grade_id: [
    { required: true, message: trans(`${langKey}.grade_id.req`) },
  ],
  designation_id: [
    { required: true, message: trans(`${langKey}.designation_id.req`) },
  ],
  job_title_id: [
    { required: true, message: trans(`${langKey}.job_title_id.req`) },
  ],
  salary: [
    { required: true, message: trans(`${langKey}.salary.req`) },
  ],

  employment_id: [
    { required: true, message: trans(`${langKey}.employment_id.req`) },
  ],
};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}

/*
on change date
request->companyPromotionRequests/getExpectedTime?&promotion_date=2023-02-01T00:00:00.000Z&employment_id=fcf1b373-295f-4c2f-967b-9c830ceacd12
payload={
  promotion_date: 2023-02-01T00:00:00.000Z
employment_id: fcf1b373-295f-4c2f-967b-9c830ceacd12
}


on save
request->/companyPromotionRequests?page=1

payload={
  file_attachment: undefined
promotion_request: {"behalf_employment_id":"d46dfabc-2966-42ca-a990-c7bfa0ef4343","is_on_behalf":true,"employment_id":"fcf1b373-295f-4c2f-967b-9c830ceacd12","date":"2023-02-01T00:00:00.000Z","expected_check_in":"2023-02-01T05:00:00.000Z","expected_check_out":"2023-02-01T13:00:00.000Z","punch_type":"Check In","punch_time":"2023-02-01T05:00:00.000Z","description":"test"}
}
*/